export default {
    comm: {  //共用     
        back: '返回',
        messagetitle: '單據資訊',
        detailtitle: '詳細資訊',
        login: '登入',
        default: '首頁',
        transaction:'交易',
        OrderManagement:'訂單管理',
        ReturnManagement:'退貨管理',
        apFundQuery:'應付查詢',
        OtherApplycations:'其他申請',
        operationmenu: '操作選單',
        download: '下載中心',
        sortfile: '分類文件',
        help: '幫助中心',
        helpdetail: '文章詳情',
        inform:'通知中心',
        report: '報表',
        bulletin:'公告',
        bulletindetail:'公告詳情',
        company: '廈門正航軟體科技有限公司',
        number: '序',
        startdate: '開始日期',
        enddate: '結束日期',
        alltype: '所有類別',
        tip: '提示',
        tipContent:'提示內容',
        message:'消息',
        unselectwarning:'請至少選擇一項',
        viewmore:'查看更多',
        confirm:'確定',
        updatePassword:'修改密碼成功',
        btnyes:'是',
        btnno:'否',
        selectexport:'請選擇一個拋出格式',
        selectprint:'請選擇一個列印格式',
        uploadFile:'上傳附件',
        viewFile:'查看附件',
        chooseFile:'選擇文件',
        uploadConfirmText:'確認上傳',
        uploadTiptxt:'將單個文件（不超過20M）拖到此處，或',
        uploadClick:'點擊上傳',
        uploadSuccess:'上傳成功！',
        deleteSuccess:'刪除成功！',
        cancelDelete:'已取消刪除',
        deleteFileTip:'將刪除該附件，是否繼續？',
        allFileType:'所有文件',
        fileTypeListTxt:'支援上傳格式：',
        fileTypeList:'doc、docx、xlsx、xls、ppt、pptx、txt、jpg、png、gif、bmp、zip、rar、7z、pdf、xmind',
        fileSizeTip:'文件過大,請上傳小於等於20M的文件!',
        fileSpecialCharTip:'文件有特殊字符,文件名中不可存在特殊字符,請重新上傳!',
        fileMaxNumberTip:'文件上傳數量已達上限!',
        fileNullTip:'請選擇要上傳的文件!',
        allowFileNumberTip:',最多可同時上傳3個附件!',
        cancelText:'取消',
        copyClick:'點擊複製詳情',
        copyFinished:'已複製到剪切板！',
        copyError:'當前瀏覽器暫不支援自動複製，請手動選擇複製！',
        KeyIndicator:'本月關鍵指標',
        salSalesOrder:'我的訂單',
        today:'今天',
        lastWeek:'最近一周',
        lastMonth:'最近一個月',
        lastSeason:'最近一個季',
        lastYear:'最近一年',
        pagesize:'筆/頁',
        salDispatchList:'我的發貨單',
        salesReturnList:'退貨單',
        WebMaterial:'下單',
        orderImport: '訂單轉入',
        orderImportSer: '訂單轉入查詢',
        itemCodeQuery:'ItemCode詢價',
        productPicture:'Item及圖檔查詢',
        preview:'預覽',
        pubPriceQuery:'公開報價查詢',
        APSearch: '應付查詢',
        saveSuc:'保存成功',
        orderArrival:'我的到貨單',
        browseFile:'瀏覽',
        stockRemainQuery:'裕萌庫存查詢',
    },
    Login: { //登入頁
        title: '裕萌客戶支授平台',
        database: '賬套',
        userId: '帳戶',
        password: '密碼',
        rempsaaword: '記住密碼',
        login: '登入',
        environment: '環境配置',
        InstallPlugin: '擴充功能',
        HardwareInfo: '硬體資訊',
        DownloadCenter: '下載中心',
        databaseText: '賬套不允許為空！',
        userIdText: '帳戶不允許為空！',
        passwordText: '密碼不允許為空！',
        prompt: '提示',
        failure: '登入失敗！',
        userExist: '當前帳號已經在其他地方登入，如果您強制登入對方將登出，是否強制登入？',
        alreadyLogined: '當前瀏覽器已經有一個登入用戶（帳套:{0}, 帳號:{1}).如果您強制登入，此用戶將被登出，請確認是否登入？',
        screentip:'建議使用分辨率:寬1360以上,以獲得最佳體驗',
        loginload:'登入中',
        cookieload:'等待伺服器啟動中...',
        chromeoutdate:'當前瀏覽器為谷歌內核，且谷歌內核版本較低，為更好的使用經銷商平台，請及時將本瀏覽器升級至最新版本。',
        firefoxoutdate:'當前瀏覽器為火狐內核，且火狐內核版本較低，為更好的使用經銷商平台，請及時將本瀏覽器升級至最新版本。',
        outdateconfirm:'我已悉知',
        outdatecancel:'三十天內不再提示',
        webVersion:'版本',
        loginErrorTip:'當前會話不存在用戶訊息, 請登入!',
        serverErrorTip:'服務連線異常，請聯絡管理員重啟web服務！'
    },
    APSearch: { //應付查詢
        messagedate: '日期',
        billTypeAuto: '期初應收',
        typeNameYF: '應付',
        typeNameYS: '應收',
        typeNameYuF: '預付',
        typeNameYuS: '預收',
        inputpls: '請輸入',
        compName:'客戶',
        documenttype: '單據種類',
        messagenumber: '單據編號',
        date: '單據日期',
        preRecOAmount:'預收款',
        preRecOAmountCheckText:'顯示預收款',
        amountreceivable: '應收金額',
        currentamount: '本期核銷金額 ',
        discountamount: '本期折扣金額',
        lateamount: '未核銷金額',
        summary: '彙總',
        ShowUnZeroItem:'期初為零不顯示',
        ShowUnZeroEnd:'期末為零不顯示',
        FromBillNo:'來源訂單號'
    },
    orderImport:{
        importDate:'轉入日期：',
        orderBillNoLab:'銷售訂單號：',
        orderBillNo:'銷售訂單號',
        importDateTime:'導入時間',
        customerNoLab:'客戶款號：',
        customerNo:'客戶款號',
        importSate:'狀態：',
        importSate0:'全部',
        importSate1:'僅成功轉入',
        importSate2:'僅失敗轉入',
        importSateError:'轉入失敗',
        rowNo:'序號',
        failReason:'失敗描述',
        isCustUsed:'指定供應商',
        materialSpec:'中文描述',
        lengthLable:'長度',
        lengthUnit:'長度單位',
        colorLable:'顏色',
        colorName:'顏色中文',
        numLable:'數量',
        addrLale:'地址編號',
        sucTabLable:'轉入成功的記錄',
        errorTabLable:'轉入失敗的記錄',
        searchTip:'請選擇具體條件，以免影響查詢效率',
        fileTypeLab:'文件格式：',
        downloadLab:'點擊下載模板',
        downloadName:'裕萌集團下載模版'
    },
    UrgentQuery:{
        title:'加急查詢',
        X_FillDate:'填寫日期：',
        BillNo:'訂單號碼：',
        customerNoLab:'客戶款號：',
        urgentDealStateName:'加急處理狀態：',
        BillDate:'下單日期：',
        urgentDealState0:'全部',
        urgentDealState1:'未處理',
        urgentDealState2:'廠商回覆中',
        urgentDealState3:'已處理',
        urgentDealState4:'已中止',
        fillDate:'填寫日期',
        X_ReplyDate:'YKK完工日期',
        X_YKKCompleteDate:'YKK預測完工日',
        X_YKKDeliverDate:'YKK預測發貨日',
        X_PredictDelDate:'加急預計出貨日期',
    },
    ShipmentQuery:{
        title:'緊急出貨查詢',
        BillDate:'申請日期：',
        urgentShipStateName:'緊急出貨申請狀態：',
        meterialSpe:'品名：',
        X_CarryingType:'出貨方式',
        X_IsPartShipment:'部分出貨',
        X_OperaExplain:'業務說明',
        X_ShipResult:'出貨結果',
        X_ExpCompleteDate:'預計完工日期',
        X_UrgentShipDate:'申請日期',
        X_UrgentShipReplyDate:'回覆日期',
        urgentShipState:'狀態',
    },
    itemCodeQuery:{//ItemCode詢價
        supplierId:'供應商代碼：',
        length:'長度',
        lenUnit:'長度單位',
        numberId:'數量',
        rowNo:'序號',
        supplier:'供應商',
        unit:'單位',
        account:'折扣',
        sUnitId:'交易單價',
        countFomu:'計算公式',
        matchWarn:'未匹配到供應商資訊',
        inputCode:'請輸入ItemCode',
        lenUnitWarn:'長度不為空時，長度單位必填',
        watchFomu:'查看公式',
        lenUnitSelC:'C，釐米',
        lenUnitSelI:'I，英吋',
        invoText:'開專票',
    },
    productPicture:{//Item及圖檔查詢
        warnText:'該界面可以查詢不同組織ITEM，但是如果查詢具體ITEMCODE價格，需要進入相應組織查詢',
        materialSpec:'中文名稱',
        supplier:'供應商',
        pic1:'圖檔1',
        pic2:'圖檔2',
        pic3:'圖檔3',
    },
    pubPriceQuery:{//公開報價查詢
        type: '分類：',
        typeSel2:'拉頭',
        typeSel3:'表面處理',
        basZipId:'基礎拉鏈編號：',
        pullHeadId:'拉頭編號：',
        faceId:'表面處理編號：',
        specId:'特殊處理編號：',
        supplierId:'供應商編號：',
        supplier:'供應商',
        basZipCode:'基礎拉鏈代碼',
        basZipName:'基礎拉鏈',
        pullHeadCode:'拉頭代碼',
        faceCode:'表面處理代碼',
        specCode:'特殊處理代碼',
        specName:'特殊處理',
        rLengths:'基準長度',
        lUnitId:'長度單位',
        noTaxPrice:'未稅標準報價',
        lnchPrice:'進寸價格（公分）',
        basZipWarn:'基礎拉鏈必填！',
        pullWarn:'基礎拉鏈、拉頭必填！',
        faceWarn:'基礎拉鏈、表面處理必填！',
        specWarn:'基礎拉鏈、特殊處理必填！'
    },
    orderArrival:{//我的到貨單查詢
        orderArrivalSearch:'到貨單查詢',
        reciveDate:'到貨日期',
        orderBillNo:'銷售訂單號：',
        customerNoLab:'客戶款號：',
        inputpls:'請輸入',
        fromOrderBillNo:'訂單號',
        custNumber:'款號（原）',
        receivingSQty:'到貨數量',
        materialSpec:'品名（中文描述）',
        address:'到貨地',
        operation:'操作',
    },
    OrderArrivalDetail:{
        orderDetail:'到貨單詳情',
        BillNo:'單號：',
        BillDate:'下單時間：',
        BizPartnerName:'訂貨客戶：',
        OAmount:'參考總金額：',
        RowNo:'序號',
        orderBillNo:'訂單號',
        length:'長度',
        lengthUnit:'長度單位',
        color:'顏色',
        batchNo:'批號',
        SQuantity:'到貨數量',
        ArrivalData:'到貨日期',
        ArrivalAddress:'到貨地',
    },
    salSalesOrder:{//訂單查詢
        orderSearch:'訂單查詢',
        orderDate:'單據日期：',
        orderBillNo:'單據編號：',
        FOrgName:'公司：',
        inputpls:'請輸入',
        BillDate:'下單時間',
        BillNo:'單號',
        BizPartnerName:'訂單客戶',
        OAmount:'金額',
        CurrentState:'狀態',
        PermitState:'審核狀態',
        efficient:'生效',
        unefficient:'未生效',
        closed:'結案',
        audited:'已審核',
        auditting:'審核中',
        unaudit:'未審核',
        operation:'操作',
        CurrId:'幣別',
        customerNoLab:'款號：',
        X_NewDate:'新交期：',
        totleNum:'總數量：',
        newDate:'新交期',
        preDate:'原交期',
        customerNo:'款號',
        totalSQty:'總數量',
        strPrice:'含稅總金額',
        urgentResult:'加急結果',
        urgentDealStateName:'加急處理狀態',
        lateOrderReason:'遲單原因',
        noDelDateReason:'無交期原因',
        urgentShipStateName:'緊急出貨申請狀態',
        lateOrderExpDate:'遲單預計出貨日期',
        urgentApplay:'加急申請',
        urgentShipApplay:'緊急出貨申請',
        unSelectTip:'未勾選行項，請選擇！',
        Select110Tip:'一次性最多只能選擇10筆進行{0}',
        applyError1:'序號{0}訂單號碼{1}的出庫狀態為完成，不能進行{2}！',
        applyError2:'序號{0}訂單號碼{1}的{2}為廠商回覆中，不能進行{3}！',
        applyError3:'100條以下交期5天內不可出貨！(序號：{0},訂單號碼:{1})',
        applyError4:'100條以上交期9天內不可出貨！(序號：{0},訂單號碼:{1})',
        urgentLevel:'緊急程度',
        urgentLevel0:'普通',
        urgentLevel1:'加急',
        urgentLevel2:'特急',
        urgentReson:'加急原因',
        hopeDate:'希望日期',
        orderNo:'訂單號碼',
        customerNo2:'客戶款號',
        meterialSpe:'品名規格',
        sQty:'數量',
        supplier:'廠商',
        newDate2:'最新交期',
        commitBtn:'提交',
        urgentError1:'當緊急程度為“特急”時，加急原因不可為空。',
        urgentError2:'序號{0}訂單號碼{1}的希望日期已過',
        urgentError3:'最新交期早於本次申請的希望日期，請確認。',
        shipmentApply:'緊急出貨申請',
        urgentLeave:'出貨緊急程度',
        isPartShipment:'是否部分出貨',
        operaExplain:'業務說明',
        urgentTypeName:'加急緊急程度',
        personId:'業務人員',
        BizPartnerId:'客戶代碼',
        shortName:'客戶簡稱',
        orgId:'組織',
        X_Or:'OR號碼',
        sUnitId:'交易單位',
        batchNo:'批號',
        YKKStatus_En:'YKK狀態-英',
        YKKStatus:'YKK狀態',
        supplier:'供應商',
        urgentWarnText:'加急申請注意事項:1、要求7天內出貨的訂單請務必在下單當天或第二天提出加急請求;2、下單后請及時查看交期，如不滿足請立即提出加急請求，以便我司與YKK盡早協調提前材料，安排上線生產，請杜絕即將交貨才安排提出;3、如三天之內我司沒有回復加急結果，請默認視為無法提前;4、加急訂單是YKK特殊調整生產線，在實際生產中不能完全保證100%按提前后的貨期出貨，可能會有遲單，遇到這種情況，不接受索賠;',
    },
    salSalesOrderDetail:{
        orderDetail:'訂單詳情',
        BillNo:'單號：',
        BillDate:'下單日期：',
        BizPartnerName:'訂貨客戶：',
        OAmount:'參考總金額：',
        Remark:'訂單備註：',
        remark:'備註',
        CurrentState:'狀態：',
        PermitState:'審核狀態：',
        RowNo:'序號',
        rowCode:'標識號',
        messagenumber: '訂單號：',
        messagedate: '下單日期',
        compName: '客戶',
        amount: '金額',
        checkstate: '確認狀態',
        goodsstate: '發貨狀態',
        purchaser: '採購員',
        OAmountWithTax:'小計',
        receiveOrgName: '需求組織',
        number: '序',
        MaterialId: '產品代碼',
        MaterialName: '產品名稱',
        MaterialSpec: '品名（中文描述）',
        SQuantity: '交易數量',
        Quantity:'基本數量',
        SPrice: '交易價',
        Address: '收貨地址',
        RowState:'行項狀態',
    },
    salDispatchList:{//發貨單
        orderSearch:'發貨單查詢',
        orderDate:'發貨日期：',
        orderBillNo:'銷售訂單號：',
        FOrgName:'公司：',
        inputpls:'請輸入',
        BillDate:'發貨日期',
        TotalSQty:'發貨數量（總）',
        BillNo:'單號',
        BizPartnerName:'訂單客戶',
        OAmount:'金額',
        CurrentState:'狀態',
        PermitState:'審核狀態',
        efficient:'生效',
        unefficient:'未生效',
        closed:'結案',
        audited:'已審核',
        auditting:'審核中',
        unaudit:'未審核',
        operation:'操作',
        CurrId:'幣別',
        Address:'發貨地址',
        ShortNameString:'物流方式',
        X_LogBillNoString:'物流單號',
        X_NumberString:'件數'
    },
    salDispatchListDetail:{
        orderDetail:'發貨單詳情',
        BillNo:'單號：',
        BillDate:'下單時間：',
        orderBillNo:'訂單號',
        BizPartnerName:'訂貨客戶：',
        OAmount:'參考總金額：',
        Remark:'訂單備註：',
        remark:'備註',
        CurrentState:'狀態：',
        PermitState:'審核狀態：',
        RowNo:'序號',
        rowCode:'標識號',
        messagenumber: '單號',
        messagedate: '日期',
        compName: '客戶',
        amount: '金額',
        checkstate: '確認狀態',
        goodsstate: '發貨狀態',
        purchaser: '採購員',
        OAmountWithTax:'含稅金額',
        receiveOrgName: '需求組織',
        number: '序',
        MaterialId: '產品代碼',
        MaterialName: '產品名稱',
        MaterialSpec: '品名（中文描述）',
        SQuantity: '數量',
        Quantity:'基本數量',
        SPrice: '交易價',
        OAmountWithTax: '含稅金額',
        Address: '收貨地址',
        RowState:'行項狀態',
        TotalSQty:'訂單總數',
        InventoryState:'發貨狀態',
        batchNo:"批號",
    },
    salesReturnList:{//退貨單
        orderSearch:'退貨單查詢',
        orderDate:'單據日期：',
        orderBillNo:'單據編號：',
        FOrgName:'公司：',
        inputpls:'請輸入',
        BillDate:'下單時間',
        BillNo:'單號',
        BizPartnerName:'訂單客戶',
        OAmount:'金額',
        CurrentState:'狀態',
        PermitState:'審核狀態',
        efficient:'生效',
        unefficient:'未生效',
        closed:'結案',
        audited:'已審核',
        auditting:'審核中',
        unaudit:'未審核',
        operation:'操作',
        CurrId:'幣別'
    },
    salesReturnListDetail:{
        orderDetail:'訂單詳情',
        BillNo:'單號：',
        BillDate:'下單日期：',
        BizPartnerName:'訂單客戶：',
        OAmount:'參考總金額：',
        Remark:'備註：',
        remark:'備註',
        CurrentState:'狀態：',
        PermitState:'審核狀態：',
        RowNo:'序號',
        rowCode:'標識號',
        messagenumber: '單號',
        messagedate: '日期',
        compName: '客戶',
        amount: '金額',
        checkstate: '確認狀態',
        goodsstate: '發貨狀態',
        purchaser: '採購員',
        OAmountWithTax:'含稅金額',
        receiveOrgName: '需求組織',
        number: '序',
        MaterialId: '產品代碼',
        MaterialName: '產品名稱',
        MaterialSpec: '產品規格',
        SQuantity: '交易數量',
        Quantity:'基本數量',
        SPrice: '交易價',
        OAmountWithTax: '含稅金額',
        Address: '收貨地址',
        RowState:'行項狀態',
    },
    button: { //按鈕
        Cancel:'取消',
        cancel: '取 消',
        determine: '確 定',
        reset: '重 置',
        search: '搜 索',
        check: '查看',
        addnew:'新增',
        query:'查詢',
        print: '列印',
        downloadAccess:'下載附件',
        downloadBillAccess:'下載訂單所有附件'
    },
    Default: { //首頁
        NumOfShipped:'已發貨訂單筆數',
        NumOfNewOrdThisMon:'新下單產品數量',
        NumOfReturnOrdThisMon:'退貨數量',
        TheTips:'提醒事項',
        PendingOrder:'未生效訂單筆數',
        NumOfUnShip:'未出庫訂單筆數',
        NumOfUnfinReturn:'退貨未完成筆數',
        information:'消息區',
        bulletin:'公告區',
        newestdownload:'下載中心',
        nonewestdownload:'暫無最新下載',
        nobulletin:'暫無公告',
        noinformation:'暫無消息',
    },
    Download: { //下載中心
        inputpls: '請輸入',
        name: '名稱',
        type: '分類',
        operation: '操作',
        intro: '簡介',
        date: '日期',
        download: '下載',
        recupdate: '附件最近上傳時間',
        accessoryname: '附件名稱',
        orderinprogress: '進行中的訂單',
        viewall: '查看所有',
        viewalldrawings: '查看所有圖紙',
        viewchange: '只查看變更',
        viewchangedrawings: '只查看變更圖紙',
        batchdownall: '批次下載所有圖紙',
        batchdownchange: '批次下載變更圖紙',
        clickdownload: '點擊下載',
        downloadall: '批量下載',
        To: '至',
        unselecttip:'您選擇的訂單暫未有變更圖紙！',
        noacc:'無附件',
        number:'序號',
        batchdownacc:'下載所有附件',
        nopower:'無下載權限'
    },
    HelpCenter: { //幫助中心
        inputpls: '請輸入',
        name: '名稱',
        billNo:'單據編號',
        type: '分類',
        operation: '操作',
        date: '上傳時間',
        updatetime: '更新時間',
        publishtime: '發佈時間'
    },
    BulletinCenter:{//公告中心
        inputpls: '可搜索主題名稱或公告內容',
        sysbulletin:'系統公告',
        salbulletin:'系統更新',
        epbulletin:'企業通訊',
        publisher:'發佈人',
        maintitle:'主題',
        keyword:'關鍵字',
        uplaodtime:'上傳時間',
        sendtime:'發送時間',
        downloadAccess:'下載附件'
    },
    Order: { //訂單
        messagedate: '單據日期',
    },
    Home: {
        changepassword: '修改密碼',
        billsetting: '單據設定',
        register: '登入資訊',
        delivercar: '購物車',
        back: '退出',
        oldpassword: '舊密碼：',
        newpassword: '新密碼：',
        confirmpassword: '確認密碼：',
        oldpswpls: '請輸入舊密碼',
        newpswpls: '請輸入新密碼',
        againpsw: '請再次輸入密碼',
        errpsw: '兩次輸入密碼不一致!',
        symbolerr: '密碼中不可包含特殊字符“<”或“>”',
        logininfo:'登入資訊',
        createtime:'創建時間',
        lastlogindate:'登入時間',
        ipaddress:'本次登入IP',
        membertype:'用戶類型',
        commonuser:'普通用戶',
        tempuser:'臨時帳戶',
        client:'客戶',
        supplier:'供應商',
        unknow:'未知',
        toolbarShowStyle:'工具列顯示方式',
        showIcon:'只顯示圖標',
        showIconAndText:'顯示圖標和文本',
        showText:'只顯示文本',
        fieldRawTextType:'欄位顯示風格',
        showcodeandname:'顯示代碼和名稱',
        showname:'顯示名稱',
        showcode:'顯示代碼',
        billsettingsucess:'單據設定成功',
        oldpwderror:'密碼框內內容不得為空',
        PhoneNumber:'聯絡方式',
        userInfo:'用戶資訊',
        customer:'客戶',
        email:'聯絡郵箱',
        Address:'送貨地址',
        Country:'國家/地區',
        Province:'省份',
        City:'城市',
        ContactAddress:'聯絡地址',
        Postalcode:'郵遞區號'
    },
    StockRemainQuery:{//裕萌库存查询
        materialSpec:'中文名稱',
        color:'顏色編號',
        length:'長度',
        supplier:'供應商',
        wareHouseCode:'倉庫編號',
        wareHouseAddress:'倉庫地址',
        lengthUnit:'長度單位',
        numberId:'數量',
        unit:'基本單位',
        basZip:'基礎拉鏈',
        queryWarn:'ItemCode、ItemName、中文名稱、基礎拉鏈需至少一個必填！',
        warnText:'溫馨提示：Itemcode、ItemName、中文名稱、基礎拉鏈需至少一個必填！',
        orderNum:'下單數量',
        orderBtn:'批量下單（已選{0}項）',
        orderConfirm:'批量下單確認',
        Address:'送貨地址',
        ContactPer:'聯繫人',
        PhoneNumber:'聯繫電話',
        InvoType:'開票類型',
        OrderTableTitle:'已下單項（{0}項）',
        Confirm:'確認下單',
    },
}